(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["elsniva-moments"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('elsniva-moments')){
customElements.define('elsniva-moments',class extends HTMLElement{
connectedCallback(){
this.viewport=this.querySelector('.elsniva-moments__viewport');
this.track=this.querySelector('.elsniva-moments__track');
this.button=this.closest('section').querySelector('[data-pause]');
this.abort=new AbortController();
const options={signal:this.abort.signal};
this.paused=matchMedia('(prefers-reduced-motion: reduce)').matches;
this.hovered=false;this.interacting=false;this.visible=false;
this.originals=[...this.track.children];
this.originals.forEach(item=>{const copy=item.cloneNode(true);copy.setAttribute('aria-hidden','true');copy.removeAttribute('data-shopify-editor-block');this.track.append(copy)});
this.updateButton=()=>{this.button.textContent=this.paused?this.dataset.playLabel:this.dataset.pauseLabel;this.button.setAttribute('aria-pressed',String(this.paused))};
this.updateButton();
this.button.addEventListener('click',()=>{this.paused=!this.paused;this.updateButton()},options);
this.viewport.addEventListener('pointerenter',e=>{if(e.pointerType==='mouse')this.hovered=true},options);
this.viewport.addEventListener('pointerleave',()=>{this.hovered=false},options);
this.viewport.addEventListener('pointerdown',()=>{this.paused=true;this.updateButton()},options);
this.viewport.addEventListener('focusin',()=>{this.interacting=true},options);
this.viewport.addEventListener('focusout',()=>{this.interacting=false},options);
this.viewport.addEventListener('wheel',()=>{this.paused=true;this.updateButton()},options);
this.observer=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting});
this.observer.observe(this);
let last=0;let position=this.viewport.scrollLeft;
const tick=time=>{
const elapsed=last?Math.min(time-last,40):0;last=time;
if(this.visible&&!this.paused&&!this.hovered&&!this.interacting&&!document.hidden){
const boundary=this.track.children[this.originals.length].offsetLeft-this.track.children[0].offsetLeft;
position+=elapsed*.024;
if(boundary&&position>=boundary)position-=boundary;
this.viewport.scrollLeft=position;
}else{position=this.viewport.scrollLeft}
this.frame=requestAnimationFrame(tick);
};
this.frame=requestAnimationFrame(tick);
}
disconnectedCallback(){cancelAnimationFrame(this.frame);this.abort?.abort();this.observer?.disconnect();this.track?.querySelectorAll('[aria-hidden="true"]').forEach(el=>el.remove())}
});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  function setupSzykFooterAccordions(root) {
    const desktop = window.matchMedia('(min-width: 700px)');
    root.querySelectorAll('.szyk-footer-accordion').forEach((details) => {
      if (details.dataset.szykInitialized) return;
      details.dataset.szykInitialized = 'true';
      const sync = () => { details.open = desktop.matches; };
      sync();
      desktop.addEventListener('change', sync);
      details.querySelector('summary')?.addEventListener('click', (event) => {
        if (desktop.matches) event.preventDefault();
      });
    });
  }
  setupSzykFooterAccordions(document);
  document.addEventListener('shopify:section:load', (event) => setupSzykFooterAccordions(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["szyk-privacy"]) return;
  try {
    
document.querySelectorAll('[data-szyk-privacy]').forEach(function(form){
  const status=form.querySelector('[role="status"]');
  const button=form.querySelector('button');
  if(!window.Shopify||!Shopify.loadFeatures){status.textContent=form.dataset.error;return;}
  Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],function(error){
    if(error||!Shopify.customerPrivacy){status.textContent=form.dataset.error;return;}
    const consent=Shopify.customerPrivacy.currentVisitorConsent();
    ['preferences','analytics','marketing'].forEach(function(name){form.elements[name].checked=consent[name]==='yes';});
    button.disabled=false;
  });
  form.addEventListener('submit',function(event){
    event.preventDefault();
    if(button.disabled)return;
    button.disabled=true;
    const consent={preferences:form.elements.preferences.checked,analytics:form.elements.analytics.checked,marketing:form.elements.marketing.checked};
    Shopify.customerPrivacy.setTrackingConsent(consent,function(result){
      status.textContent=result&&result.error?form.dataset.error:form.dataset.success;
      button.disabled=false;
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["szyk-sample-reviews"] && !Shopify.designMode) return;
  try {
    
  if(!customElements.get('szyk-sample-reviews'))customElements.define('szyk-sample-reviews',class extends HTMLElement{
    async connectedCallback(){
      if(this.ready)return;this.ready=true;this.page=1;this.pageSize=Number(this.dataset.pageSize)||12;this.labels=JSON.parse(this.querySelector('[data-labels]').textContent);this.grid=this.querySelector('[data-grid]');this.filter=this.querySelector('[data-filter]');
      this.querySelector('[data-prev]').addEventListener('click',()=>{this.page--;this.render();this.scrollToCards()});this.querySelector('[data-next]').addEventListener('click',()=>{this.page++;this.render();this.scrollToCards()});this.filter.addEventListener('change',()=>{this.page=1;this.render()});
      try{const response=await fetch(this.dataset.source);if(!response.ok)throw new Error('load');const data=await response.json();if(data.sample!==true||!Array.isArray(data.reviews))throw new Error('sample');this.reviews=data.reviews.filter(r=>r.sample===true&&[3,4,5].includes(r.rating));this.querySelector('[data-total]').textContent=this.reviews.length;const average=this.reviews.reduce((sum,r)=>sum+r.rating,0)/this.reviews.length;this.querySelector('[data-average]').textContent=new Intl.NumberFormat(document.documentElement.lang||'pl',{maximumFractionDigits:1}).format(average)+' / 5';this.render()}catch(error){this.grid.textContent=this.labels.error;this.grid.setAttribute('aria-busy','false')}
    }
    element(tag,className,text){const el=document.createElement(tag);if(className)el.className=className;if(text!==undefined)el.textContent=text;return el}
    card(review){
      const card=this.element('article','szyk-samples__card');
      if(review.image){const img=this.element('img','szyk-samples__photo');const url=new URL(review.image);if(url.hostname==='cdn.shopify.com'){url.searchParams.set('width','600');img.src=url.href;img.alt=this.labels.photo+': '+review.product;img.width=review.imageWidth;img.height=review.imageHeight;img.loading='lazy';card.append(img)}}
      const content=this.element('div','szyk-samples__content');const stars=this.element('div','szyk-samples__stars');stars.setAttribute('role','img');stars.setAttribute('aria-label',review.rating+' / 5 '+this.labels.stars);stars.append(this.element('span','', '★'.repeat(review.rating)),this.element('span','szyk-samples__muted-star','★'.repeat(5-review.rating)));
      content.append(stars,this.element('p','szyk-samples__name',review.name),this.element('h3','',review.title),this.element('p','szyk-samples__body',review.body));
      if(review.product){const link=this.element('a','szyk-samples__product',review.product);link.href=review.productUrl;content.append(link)}card.append(content);return card;
    }
    render(){if(!this.reviews)return;const rows=this.filter.value==='all'?this.reviews:this.reviews.filter(r=>r.rating===Number(this.filter.value));const pages=Math.max(1,Math.ceil(rows.length/this.pageSize));this.page=Math.min(pages,Math.max(1,this.page));const fragment=document.createDocumentFragment();rows.slice((this.page-1)*this.pageSize,this.page*this.pageSize).forEach(r=>fragment.append(this.card(r)));if(!rows.length)fragment.append(this.element('p','',this.labels.empty));this.grid.replaceChildren(fragment);this.grid.setAttribute('aria-busy','false');this.querySelector('[data-prev]').disabled=this.page===1;this.querySelector('[data-next]').disabled=this.page===pages;this.querySelector('[data-status]').textContent=this.labels.page+' '+this.page+' '+this.labels.of+' '+pages}
    scrollToCards(){this.querySelector('.szyk-samples__header').scrollIntoView({block:'start',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'})}
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["szyk-style-gallery"] && !Shopify.designMode) return;
  try {
    
  if(!customElements.get('szyk-style-gallery'))customElements.define('szyk-style-gallery',class extends HTMLElement{
    connectedCallback(){
      if(this.ready)return;this.ready=true;
      this.track=this.querySelector('.szyk-gallery__track');this.pauseButton=this.querySelector('[data-pause]');
      this.paused=this.dataset.autoplay!=='true'||window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.updatePause();
      this.querySelector('[data-prev]').addEventListener('click',()=>this.move(-1));
      this.querySelector('[data-next]').addEventListener('click',()=>this.move(1));
      this.pauseButton.addEventListener('click',()=>{this.paused=!this.paused;this.updatePause()});
      this.track.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();this.move(e.key==='ArrowRight'?1:-1)}});
      this.track.addEventListener('pointerdown',()=>{this.paused=true;this.updatePause()});
      this.timer=setInterval(()=>{if(!this.paused&&!this.matches(':hover')&&!this.contains(document.activeElement)&&this.getBoundingClientRect().top<innerHeight&&this.getBoundingClientRect().bottom>0)this.move(1)},Number(this.dataset.interval)||4500);
    }
    updatePause(){this.pauseButton.textContent=this.paused?'▶':'Ⅱ';this.pauseButton.setAttribute('aria-pressed',String(this.paused));this.pauseButton.setAttribute('aria-label',this.paused?this.pauseButton.dataset.playLabel:this.pauseButton.dataset.pauseLabel)}
    move(direction){const card=this.track.querySelector('figure');if(!card)return;const gap=parseFloat(getComputedStyle(this.track).gap)||0;const max=this.track.scrollWidth-this.track.clientWidth;let target=this.track.scrollLeft+direction*(card.offsetWidth+gap);if(direction>0&&this.track.scrollLeft>=max-4)target=0;else if(direction<0&&this.track.scrollLeft<=4)target=max;this.track.scrollTo({left:target,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'})}
    disconnectedCallback(){clearInterval(this.timer);this.ready=false}
  });

  } catch(e) { console.error(e); }
})();
})();
